<fgb-account-layout [memberName]="name() ?? ''" [pageTitle]="'account.activity.page.title'" [backButtonLink]="'/'"></fgb-account-layout>
  <div class="container">
    <ng-container *inProductCode="[productCode.Free]">
      <fgb-upgrade-banner></fgb-upgrade-banner>
      <div
        class="font-size-14 border rounded text-center px-3 pt-3 bg-white benefits-description"
        [innerHTML]="'benefits.page.description' | translate | markdownTranslate"
      ></div>
    </ng-container>
    <fgb-benefits-worksheet-list [isList]="false"></fgb-benefits-worksheet-list>
  </div>
